"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WheelCanvas = void 0;
function easing(t, c, d) {
    const x = t / d;
    return 1 - (Math.pow(1 - x, 5) * c);
}
class WheelCanvas {
    constructor(ctx) {
        this.itemColors = [];
        // animations
        this.isRunning = false;
        this.lastTimestamp = null;
        this.totalElapsedTime = 0;
        this.highlightDurationTotal = 15000;
        this.highlightIntervals = 500;
        this.highlightLastTs = null;
        this.highlightCurrent = 0;
        this.highlightItemNumber = 0;
        this.outerWidth = 34;
        this.currentClick = 0;
        this.currentAngle = 0;
        this.lightsOn = [];
        this.update = (timestamp) => {
            if (!this.isRunning || this.totalElapsedTime > this.rotationTime) {
                console.warn(this.totalElapsedTime);
                this.isRunning = false;
                this.winSound.currentTime = 0;
                this.winSound.play();
                const i = Math.floor(this.currentAngle / (Math.PI * 2));
                this.initAngle = (this.currentAngle - (Math.PI * 2 * i));
                this.onAngleChanged(this.initAngle);
                this.init();
                //
                // this.clear();
                // this.drawOuterCircle();
                // this.drawAllItems();
                // this.drawInnerCircle();
                // this.drawPointer();
                this.highlightWinner();
                return;
            }
            requestAnimationFrame(this.update);
            const elapsedTime = this.lastTimestamp == null ? 0 : timestamp - this.lastTimestamp;
            this.totalElapsedTime += elapsedTime;
            this.lastTimestamp = timestamp;
            const easy = easing(this.totalElapsedTime, this.rotationSpeed, this.rotationTime + (this.rotationTime * this.extraStopK));
            const diffEasy = easy - this.prevEasy;
            this.prevEasy = easy;
            const rotAngle = Math.max(0, diffEasy);
            this.ctx.rotate(rotAngle);
            this.currentAngle += rotAngle;
            this.drawItemCache();
            this.drawInnerCircleCache();
            this.drawPointer();
            if (rotAngle > 0 && rotAngle < this.minSpeed && Math.random() < this.forceStopChance) {
                this.isRunning = false;
            }
            const clicks = Math.floor((this.currentAngle + this.itemAngleHalf) / this.itemAngle);
            if (clicks > this.currentClick) {
                this.clickSound.currentTime = 0;
                this.clickSound.play();
            }
            this.currentClick = clicks;
        };
        this.updateHighlightAnimation = (timestamp) => {
            if (this.highlightCurrent > this.highlightDurationTotal) {
                // this.highlightItem(this.highlightItemNumber, 0);
                this.init();
                return;
            }
            window.requestAnimationFrame(this.updateHighlightAnimation);
            if (this.highlightLastTs === null) {
                this.highlightLastTs = timestamp;
            }
            const diff = timestamp - this.highlightLastTs;
            this.highlightLastTs = timestamp;
            this.highlightCurrent += diff;
            // const t = this.highlightDurationTotal / this.highlightintervals;
            const l = this.highlightCurrent / this.highlightIntervals;
            const x = l * 2 * Math.PI;
            const i = Math.abs(Math.sin(x));
            const int = i * 20;
            this.highlightItem(this.highlightItemNumber, int);
        };
        this.ctx = ctx;
    }
    updateOptions(options) {
        const ctx = this.ctx;
        ctx.resetTransform();
        this.height = options.height;
        this.width = options.width;
        this.totalItems = options.items.length;
        this.items = options.items;
        this.itemColors = options.colors;
        this.font = options.font;
        this.baseRotationTime = options.baseRotationTime;
        this.baseRotationSpeed = options.baseRotationSpeed;
        this.textOffset = options.textOffset;
        this.stopFactor = options.stopFactor;
        this.durationFactor = options.durationFactor;
        this.speedFactor = options.speedFactor;
        this.minSpeed = options.minSpeed;
        this.forceStopChance = options.forceStopChance;
        this.highlightDurationTotal = options.highlightDurationTotal;
        this.highlightIntervals = options.highlightIntervals;
        this.lampsIntervals = options.lampsIntervals;
        this.lampsAmount = options.lampsAmount;
        this.initAngle = options.angle;
        this.onAngleChanged = options.onAngleChanged;
        this.centerX = this.width / 2;
        this.centerY = this.height / 2;
        this.radius = Math.min(this.centerX, this.centerY) - 60;
        this.innerCenterRadius = 50;
        this.itemAngle = (Math.PI * 2) / this.totalItems;
        this.itemAngleHalf = this.itemAngle / 2;
        this.lampAngle = (Math.PI * 2) / this.lampsAmount;
        this.cacheImg = document.createElement("canvas");
        this.cacheImg.width = this.width;
        this.cacheImg.height = this.height;
        this.cacheImgCtx = this.cacheImg.getContext("2d");
        this.cacheImgIn = document.createElement("canvas");
        this.cacheImgIn.width = this.width;
        this.cacheImgIn.height = this.height;
        this.cacheImgInCtx = this.cacheImgIn.getContext("2d");
        this.goldInnerGradient = ctx.createRadialGradient(15, 29, 10, 0, -3, 50);
        this.goldInnerGradient.addColorStop(0, "#ffc830");
        this.goldInnerGradient.addColorStop(0.8, "#8b7e0d");
        this.goldInnerGradient.addColorStop(0.93, "#8b7e0d");
        this.goldInnerGradient.addColorStop(1, "rgba(0,0,0,0.67)");
        this.goldOuterGradient = ctx.createRadialGradient(0, 0, this.radius + 1, 0, 0, this.radius + this.outerWidth);
        this.goldOuterGradient.addColorStop(0.01, "rgba(0,0,0,0.67)");
        this.goldOuterGradient.addColorStop(0.2, "#8b7e0d");
        this.goldOuterGradient.addColorStop(0.28, "#efb202");
        this.goldOuterGradient.addColorStop(0.58, "#dbad2c");
        this.goldOuterGradient.addColorStop(0.88, "#c6950a");
        this.goldOuterGradient.addColorStop(0.93, "#8b7e0d");
        this.goldOuterGradient.addColorStop(0.95, "#8b7e0d");
        this.goldOuterGradient.addColorStop(1, "rgba(0,0,0)");
        this.goldPointerGradient = ctx.createRadialGradient(-13, 0, 0, 0, -2, 15);
        this.goldPointerGradient.addColorStop(0, "#ffc830");
        this.goldPointerGradient.addColorStop(0.3, "#8b7e0d");
        this.goldPointerGradient.addColorStop(0.73, "#8b7e0d");
        this.goldPointerGradient.addColorStop(1, "rgba(0,0,0,0.67)");
        this.lightOff = {
            gradient: ctx.createRadialGradient(-1, 1, 1, 0, 0, 11),
            shadowColor: "black",
            shadowBlur: 4,
        };
        // this.lightOff.gradient.addColorStop(0, "#8b8b8b");
        // this.lightOff.gradient.addColorStop(0.1, "#7f7f7f");
        // this.lightOff.gradient.addColorStop(0.8, "#9c9c9c");
        // this.lightOff.gradient.addColorStop(0.88, "#6c6c6c");
        // this.lightOff.gradient.addColorStop(0.90, "#151515");
        // this.lightOff.gradient.addColorStop(1, "rgba(0,0,0)");
        this.lightOff.gradient.addColorStop(0, "#878787");
        this.lightOff.gradient.addColorStop(0.1, "#181818");
        this.lightOff.gradient.addColorStop(0.8, "#525252");
        this.lightOff.gradient.addColorStop(0.88, "#282828");
        this.lightOff.gradient.addColorStop(0.90, "#111111");
        this.lightOff.gradient.addColorStop(1, "rgba(0,0,0)");
        const lightRed = {
            gradient: ctx.createRadialGradient(-1, 1, 1, 0, 0, 11),
            shadowColor: "#ff0000",
            shadowBlur: 10,
        };
        lightRed.gradient = ctx.createRadialGradient(-1, 1, 1, 0, 0, 11);
        lightRed.gradient.addColorStop(0, "#ef8787");
        lightRed.gradient.addColorStop(0.1, "#f18181");
        lightRed.gradient.addColorStop(0.8, "#ff5252");
        lightRed.gradient.addColorStop(0.88, "#952828");
        lightRed.gradient.addColorStop(0.90, "#181111");
        lightRed.gradient.addColorStop(1, "rgba(0,0,0)");
        this.lightsOn.push(lightRed);
        const lightGreen = {
            gradient: ctx.createRadialGradient(-1, 1, 1, 0, 0, 11),
            shadowColor: "#00ff00",
            shadowBlur: 10,
        };
        lightGreen.gradient = ctx.createRadialGradient(-1, 1, 1, 0, 0, 11);
        lightGreen.gradient.addColorStop(0, "#87ef87");
        lightGreen.gradient.addColorStop(0.1, "#81f181");
        lightGreen.gradient.addColorStop(0.8, "#52ff52");
        lightGreen.gradient.addColorStop(0.88, "#289528");
        lightGreen.gradient.addColorStop(0.90, "#111811");
        lightGreen.gradient.addColorStop(1, "rgba(0,0,0)");
        this.lightsOn.push(lightGreen);
        const lightBlue = {
            gradient: ctx.createRadialGradient(-1, 1, 1, 0, 0, 11),
            shadowColor: "#0000ff",
            shadowBlur: 10,
        };
        lightBlue.gradient = ctx.createRadialGradient(-1, 1, 1, 0, 0, 11);
        lightBlue.gradient.addColorStop(0, "#8787ef");
        lightBlue.gradient.addColorStop(0.1, "#8181f1");
        lightBlue.gradient.addColorStop(0.8, "#5252ff");
        lightBlue.gradient.addColorStop(0.88, "#282895");
        lightBlue.gradient.addColorStop(0.90, "#111118");
        lightBlue.gradient.addColorStop(1, "rgba(0,0,0)");
        this.lightsOn.push(lightBlue);
        this.clickSound = new Audio(options.clickSound);
        this.clickSound.load();
        this.winSound = new Audio(options.winSound);
        this.winSound.load();
        this.clickAngle = (Math.PI * 2) / this.items.length;
        this.init();
    }
    init() {
        const ctx = this.ctx;
        ctx.resetTransform();
        this.clear();
        // base settings
        ctx.textBaseline = "middle";
        ctx.font = this.font;
        ctx.lineWidth = 2;
        ctx.imageSmoothingQuality = "high";
        this.ctx.translate(this.centerX, this.centerY);
        // this.clearWheel();
        this.drawAllItems();
        // this.drawInnerCircle();
        this.prepareCache();
        const initAngle = this.initAngle;
        if (!isNaN(initAngle)) {
            ctx.rotate(initAngle);
            this.currentAngle = initAngle;
        }
        this.drawOuterCircle();
        this.drawAllItems();
        // this.drawItemCache();
        this.drawInnerCircleCache();
        this.drawPointer();
        // this.ctx.resetTransform();
        // this.highlightWinner();
    }
    prepareCache() {
        this.clear();
        this.drawAllItems();
        const img = this.ctx.getImageData(0, 0, this.width, this.height);
        this.cacheImgCtx.putImageData(img, 0, 0);
        this.clear();
        this.drawInnerCircle();
        const img2 = this.ctx.getImageData(this.centerX - this.innerCenterRadius, this.centerY - this.innerCenterRadius, this.centerX + this.innerCenterRadius, this.centerY + this.innerCenterRadius);
        this.cacheImgInCtx.putImageData(img2, 0, 0);
    }
    clear() {
        const ctx = this.ctx;
        ctx.save();
        ctx.resetTransform();
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, this.width, this.height);
        ctx.clearRect(0, 0, this.width, this.height);
        ctx.restore();
    }
    // clearWheel() {
    //   const ctx = this.ctx;
    //   ctx.save();
    //
    //   ctx.fillStyle = "#fff";
    //
    //   ctx.beginPath();
    //   ctx.arc(0, 0, this.radius, 0, Math.PI * 2);
    //   ctx.closePath();
    //   ctx.fill();
    //
    //   ctx.restore();
    // }
    drawLamp(n, lightingOffset) {
        const ctx = this.ctx;
        ctx.save();
        ctx.rotate(this.lampAngle * n);
        ctx.translate(0, -(this.radius + (this.outerWidth / 2) + 3));
        ctx.beginPath();
        ctx.arc(0, 0, 10, 0, Math.PI * 2);
        ctx.closePath();
        if (lightingOffset > 0) {
            const light = (n + lightingOffset) % this.lightsOn.length;
            ctx.fillStyle = this.lightsOn[light].gradient;
            ctx.shadowColor = this.lightsOn[light].shadowColor;
            ctx.shadowBlur = this.lightsOn[light].shadowBlur;
        }
        else {
            ctx.fillStyle = this.lightOff.gradient;
            ctx.shadowColor = this.lightOff.shadowColor;
            ctx.shadowBlur = this.lightOff.shadowBlur;
        }
        ctx.fill();
        ctx.restore();
    }
    drawAllLamps(light) {
        for (let i = 0; i < this.lampsAmount; i++) {
            this.drawLamp(i, light);
        }
    }
    drawOuterCircle(light = 0) {
        const ctx = this.ctx;
        ctx.save();
        ctx.resetTransform();
        this.ctx.translate(this.centerX, this.centerY);
        const bound = new Path2D();
        bound.arc(0, 0, this.radius + this.outerWidth + 1, 0, Math.PI * 2);
        bound.arc(0, 0, this.radius, 0, Math.PI * 2);
        ctx.clip(bound);
        ctx.fillStyle = "#c7c7c7";
        ctx.fill(bound, "evenodd");
        // ctx.strokeStyle = "rgba(0,0,0,0.8)";
        ctx.fillStyle = this.goldOuterGradient;
        ctx.beginPath();
        ctx.arc(0, 0, this.radius, 0, Math.PI * 2);
        ctx.arc(0, 0, this.radius + this.outerWidth + 1, 0, Math.PI * 2);
        ctx.moveTo(this.radius, 0);
        ctx.closePath();
        // ctx.stroke();
        ctx.fill("evenodd");
        this.drawAllLamps(light);
        ctx.restore();
    }
    drawPointer() {
        const ctx = this.ctx;
        ctx.save();
        ctx.resetTransform();
        this.ctx.translate(this.centerX + this.radius, this.centerY);
        ctx.strokeStyle = "rgba(0,0,0,0.8)";
        ctx.fillStyle = this.goldPointerGradient;
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(0, 15);
        ctx.lineTo(0, -15);
        ctx.lineTo(-15, 0);
        ctx.lineTo(0, 15);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        ctx.restore();
    }
    drawInnerCircle() {
        const ctx = this.ctx;
        ctx.save();
        ctx.resetTransform();
        this.ctx.translate(this.centerX, this.centerY);
        ctx.fillStyle = this.goldInnerGradient;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 10;
        ctx.shadowBlur = 10;
        ctx.shadowColor = "rgba(0, 0, 0, 0.2)";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(0, 0, this.innerCenterRadius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.stroke();
        ctx.fill();
        ctx.restore();
    }
    tryWrapText(text, maxWidth, lineHeight, maxLines) {
        const words = text.split(' ');
        const lines = [];
        let line = [];
        let metrics;
        for (const word of words) {
            line.push(word);
            metrics = this.ctx.measureText(line.join(" "));
            if (metrics.width > maxWidth && line.length > 0) {
                lines.push(line.slice(0, -1).join(" "));
                line = line.slice(-1);
            }
        }
        if (line.length > 0) {
            lines.push(line.join(" "));
        }
        return lines.length > maxLines ? null : lines;
    }
    smartText(text, maxWidth) {
        var _a;
        let lines;
        const dims = this.ctx.measureText(text);
        const lineHeight = dims.actualBoundingBoxAscent * 2;
        if (dims.width > maxWidth) {
            lines = (_a = this.tryWrapText(text, maxWidth / 2 + 40, lineHeight, 2)) !== null && _a !== void 0 ? _a : this.tryWrapText(text, maxWidth / 3 + 40, lineHeight, Infinity);
        }
        else {
            lines = [text];
        }
        const height = lines.length * lineHeight;
        let n = 0;
        for (const line of lines) {
            const y = (-height / 2) + (lineHeight / 2) + (n * lineHeight);
            const x = this.radius - this.ctx.measureText(line).width - this.textOffset;
            this.ctx.fillText(line, x, y);
            n++;
        }
    }
    drawItem(item, highlight) {
        const text = this.items[item];
        const ctx = this.ctx;
        const angle = this.itemAngle * item;
        ctx.save();
        ctx.arc(0, 0, this.radius, 0, Math.PI * 2);
        ctx.clip();
        // ctx.translate(this.centerX, this.centerY);
        ctx.rotate(angle);
        const path = new Path2D();
        path.moveTo(0, 0);
        path.arc(0, 0, this.radius, -(this.itemAngle / 2), (this.itemAngle / 2));
        ctx.strokeStyle = "rgba(0,0,0,1)";
        // if (ctx.isPointInPath(path, this.centerX + this.radius - 10, this.centerY)) {
        //   ctx.fillStyle = "yellow";
        // } else {
        ctx.fillStyle = this.itemColors[item % this.itemColors.length].fill;
        // }
        ctx.stroke(path);
        if (highlight !== 0) {
            // ctx.shadowColor = "rgba(205,201,18,0.50)";
            ctx.shadowColor = this.itemColors[item % this.itemColors.length].fill;
            // ctx.shadowOffsetY = highlight;
            ctx.shadowBlur = Math.abs(highlight);
        }
        ctx.fill(path);
        // draw text
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 1;
        ctx.shadowBlur = 0.5;
        ctx.shadowColor = "rgba(0,0,0,0.3)";
        ctx.fillStyle = this.itemColors[item % this.itemColors.length].text;
        this.smartText(text, this.radius - this.textOffset - this.innerCenterRadius - 30);
        ctx.restore();
    }
    drawAllItems() {
        const ctx = this.ctx;
        // ctx.save();
        // const path = new Path2D();
        // path.arc(0, 0, this.innerCenterRadius, 0, Math.PI * 2);
        // path.arc(0, 0, this.radius, 0, Math.PI * 2);
        // ctx.clip(path, "evenodd");
        let n = 0;
        for (const item of this.items) {
            this.drawItem(n, 0);
            n++;
        }
        // ctx.restore();
    }
    drawItemCache() {
        // this.ctx.save();
        this.ctx.drawImage(this.cacheImg, -this.width / 2, -this.height / 2);
        // this.ctx.restore();
    }
    drawInnerCircleCache() {
        this.ctx.save();
        this.ctx.resetTransform();
        this.ctx.translate(this.centerX, this.centerY);
        this.ctx.drawImage(this.cacheImgIn, -(this.innerCenterRadius), -(this.innerCenterRadius));
        this.ctx.restore();
    }
    startRoll(strength) {
        if (this.isRunning) {
            return;
        }
        this.isRunning = true;
        this.lastTimestamp = null;
        this.totalElapsedTime = 0;
        this.currentClick = Math.floor((this.currentAngle + this.itemAngleHalf) / this.itemAngle);
        // this.startAngle = this.currentAngle;
        this.prevEasy = 0;
        this.rotationTime = this.baseRotationTime + ((Math.random() * this.durationFactor - (this.durationFactor / 2)) * this.baseRotationTime);
        this.rotationTime *= strength;
        this.rotationSpeed = this.baseRotationSpeed + (Math.random() * this.speedFactor - (this.speedFactor / 2)) * this.baseRotationSpeed;
        this.rotationSpeed *= strength;
        this.extraStopK = Math.random() * this.stopFactor;
        this.highlightCurrent = Infinity;
        setTimeout(() => {
            requestAnimationFrame(this.update);
        }, 10);
    }
    getCurrent() {
        const ctx = this.ctx;
        let n = 0;
        for (const item of this.items) {
            const angle = this.itemAngle * n;
            ctx.save();
            ctx.rotate(angle);
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.arc(0, 0, this.radius, -(this.itemAngle / 2), (this.itemAngle / 2));
            ctx.closePath();
            if (ctx.isPointInPath(this.centerX + this.radius - 10, this.centerY) || ctx.isPointInStroke(this.centerX + this.radius - 10, this.centerY)) {
                ctx.closePath();
                ctx.restore();
                return n;
            }
            ctx.closePath();
            ctx.restore();
            n++;
        }
    }
    highlightItem(n, intensity) {
        // this.drawOuterCircle();
        this.drawItemCache();
        this.drawItem(n, intensity);
        this.drawInnerCircleCache();
        this.drawPointer();
    }
    highlightWinner() {
        this.highlightCurrent = 0;
        this.highlightLastTs = null;
        this.highlightItemNumber = this.getCurrent();
        window.requestAnimationFrame(this.updateHighlightAnimation);
        let light = 1;
        const handler = setInterval(() => {
            if (this.highlightCurrent > this.highlightDurationTotal) {
                clearInterval(handler);
                return;
            }
            this.drawOuterCircle(light++);
        }, this.lampsIntervals);
    }
}
exports.WheelCanvas = WheelCanvas;
